import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import slugify from "react-slugify";
import { ApiLinkContext } from "../context/ApiLinkContext";
import GetInTouch from "./Home/GetInTouch";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";

const Blog = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const { blogCat, blog } = useContext(ApiLinkContext);
  const { newsId } = useParams();

  const [selectedBtn, setSelectedBtn] = useState("");
  const [visible, setVisible] = useState(20);

  const splitnewsId = newsId.split("")[0];

  const findNews = selectedBtn
    ? blog.filter((item) => item.cat == selectedBtn)
    : blog.filter((item) => item.cat == splitnewsId);
  const findCatName = blogCat.find(
    (item) => slugify(`${item.id}-${item.name}`).toLowerCase() === newsId
  );

  const handleBtn = (btnId) => {
    setSelectedBtn(btnId);
  };
  return (
    <>
      <section className="news">
        <div
          className="courses-slider swiper-container py-5"
          style={{ background: "#F5F5F5" }}
        >
          <div className="d-flex justify-content-center align-items-center projectBtn mb-5">
            {/* <NavLink>
              <button id="projectsBtn1">Bütün Xəbərlər</button>
            </NavLink> */}
            {blogCat.map((item) => {
              return (
                <NavLink
                  to={`/news/${slugify(
                    `${item.id}-${item.name}`
                  ).toLowerCase()}`}
                >
                  <button
                    id="projectsBtn1"
                    className={`btn1 ${
                      item.id == splitnewsId ? "btnActive" : ""
                    } p-3 mx-2`}
                  >
                    {item.name}
                  </button>
                </NavLink>
              );
            })}
          </div>
          <div className="d-flex justify-content-end">
            <select
              name=""
              id="newsProjects"
              onChange={(e) => setSelectedBtn(e.target.value)}
              value={selectedBtn}
            >
              {blogCat.map((item) => {
                return <option value={item.id}>{item.name}</option>;
              })}
            </select>
          </div>

          <div className="container">
            <div className="section-title">
              <h2 className="title text-center">
                {findCatName && findCatName.name}
              </h2>
            </div>
            <div className="row">
              {findNews.length > 0 &&
                findNews.slice(0, visible).map((item) => {
                  return (
                    <div className="col-lg-4 col-sm-6 col-12">
                      <NavLink
                        to={`/${slugify(
                          `${item.id}-${item.name}`
                        ).toLowerCase()}`}
                      >
                        <div className="swiper-s mb-30 mx-2 pb-5">
                          <div className="course box-shadow">
                            <div className="thumbnail">
                              <a
                                href="#"
                                className="image"
                              >
                                <img src={item.img} alt="Course Image" id="newsImg" />
                              </a>
                            </div>
                            <div className="info">
                              <h3 className="title">
                                <a href="#">
                                {language == "az"
                                  ? item.name
                                  : language == "en"
                                  ? item.nameEn
                                  : language == "ru"
                                  ? item.nameRu
                                  : language == "tr"
                                  ? item.nameTr
                                  : language == "de"
                                  ? item.nameDe
                                  : language == "pl"
                                  ? item.namePl
                                  : ""}
                                </a>
                              </h3>
                              <p>
                              {item.descrip && 
                              
                              language == "az"
                                      ? item.descrip.slice(0, 81)
                                      : language == "en"
                                      ? item.descripEn.slice(0, 81)
                                      : language == "ru"
                                      ? item.descripRu.slice(0, 81)
                                      : language == "tr"
                                      ? item.descripTr.slice(0, 81)
                                      : language == "de"
                                      ? item.descripDe.slice(0, 81)
                                      : language == "pl"
                                      ? item.descripPl.slice(0, 81)
                                      : ""}
                              
                              </p>
                              <ul className="meta">
                                <li>
                                  <i className="fas fa-file-alt" />
                                  {item.date}
                                </li>
                                <li>
                                  <i className="fas fa-user-alt" />
                                  {item.view} view
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </NavLink>
                    </div>
                  );
                })}
            </div>
            {visible < findNews.length && (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  className="btn btn-success"
                  onClick={() => setVisible((prevState) => prevState + 10)}
                >
                  DAHA ÇOX
                </button>
              </div>
            )}
          </div>
        </div>
        {findNews.length === 0 && <h2 className="text-center">Yüklənir...</h2>}
      </section>
      <GetInTouch />
    </>
  );
};

export default Blog;
